import styled from 'styled-components';
import { ReactComponent as IconArrowRight } from 'asserts/icons/ic_arrow_right_black.svg';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { useNavigate } from 'react-router-dom';
import DefaultButton from 'components/button/DefaultButton';

const JoinComplete = () => {
  const navigate = useNavigate();

  const handleClickMoveMainPage = () => {
    navigate('/');
  };

  return (
    <Wrappaer>
      <ImageWrapper>
        <Title>엑스바디 비즈멤버십 회원가입을 축하합니다.</Title>
        <div>
          <img src="/images/main_ticket.png" alt="티켓 이미지" />
        </div>
        <DefaultButton
          onClick={handleClickMoveMainPage}
          text="홈으로 가기"
          rightIcon={<IconArrowRight />}
        />
      </ImageWrapper>
    </Wrappaer>
  );
};

export default JoinComplete;

const Wrappaer = styled.div`
  position: relative;
  height: 100vh;
`;

const Title = styled.h2`
  margin-bottom: 64px;
  ${font.d1_bold};
  background: var(--Gradient-Type-1, linear-gradient(270deg, #84ffe9 0%, #acaaff 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  & > div {
    display: flex;
    justify-content: center;

    img {
      width: 440px;
    }
  }

  p {
    position: absolute;
    bottom: -22px;
    left: 50%;
    transform: translateX(-50%);
  }

  button {
    display: inline-flex;
    width: 252px;
    height: 44px;
    justify-content: center;
    align-items: center;
    gap: 12px;
    border-radius: 24px;
    border: 1px solid ${color.black2} !important;

    span {
      color: ${color.black2};
      ${font.h3_medium};
    }
  }
`;
